export const ANALYTICS_EVENTS = {
  ADVISOR_ALERT_SET: 'advisor alert set',
  LEAVE_FEEDBACK: 'leave feedback',
  CATEGORY: 'category',
  TERMS_AND_POLICIES_UPDATE_CLICKED: 'terms and policies update clicked',
  CUSTOMER_SENT_A_BONUS: 'customer sent a bonus',
  SMS_VERIFICATION_REQUESTED: 'sms verification requested',
  PHONE_NUMBER_VERIFIED: 'phone number verified',
  PHONE_SIGNUP_ADD_EMAIL_CLICKED: 'phone signup add email clicked',
  DOWNLOAD_APP: 'download app'
} as const;

export type AnalyticsEventKey = keyof typeof ANALYTICS_EVENTS;
export type AnalyticsEventValue = typeof ANALYTICS_EVENTS[AnalyticsEventKey];

export const CUSTOMER_SUPPORT_EVENTS = {
  SUPPORT_CLICKED: 'customer support lobby page clicked'
} as const;
